// extracted by mini-css-extract-plugin
module.exports = {"link_button":"LinkButton_link_button__EuHY7","link_button_title":"LinkButton_link_button_title__b6o0p","submit_button":"LinkButton_submit_button__ttTus"};